module.exports = __webpack_public_path__ + "static/media/playback.1dce24e2.png";